import util from '@/utils/util'

// 时间格式化
export function datetime(v) {
  if (v === null || v === undefined || v === '') return '--'
  if (typeof v === 'number') {
    if (v <= 0) return '--'
    // 10 位是秒，13 位是毫秒
    const ms = String(v).length <= 10 ? v * 1000 : v
    return util.formatTime(ms, 'yyyy-MM-dd hh:mm')
  }
  const s = String(v)
  // 已经是 YYYY-MM-DD HH:mm(:ss) 的字符串：只砍掉秒，不进 Date 兜一圈
  // （ios 上 'YYYY-MM-DD HH:mm:ss' 直接 new Date 会得到 Invalid Date）
  const m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/)
  if (m) return Number(m[1].slice(0, 4)) < 1970 ? '--' : m[1] + ' ' + m[2]
  if (/^-?\d+$/.test(s)) return datetime(Number(s))
  return s
}

export default { datetime }
